import { Injectable } from '@angular/core';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  appInsights: ApplicationInsights;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: false,
        distributedTracingMode: DistributedTracingModes.W3C,
        disableCorrelationHeaders: false,
        enableDebug: false,
        enableCorsCorrelation: false,
        enableRequestHeaderTracking: false,
        autoTrackPageVisitTime: false,
      },
    });
   // this.appInsights.loadAppInsights();
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }
}
